// src/realtime.ts
import { io } from "socket.io-client";

/** Détecte si on est dans l’UI Admin (chemin /admin ou variable d’env) */
export function isAdminContext(): boolean {
  try {
    const p = window.location.pathname;
    if (/^\/admin(\/|$)/.test(p)) return true;
    if ((process.env as any).VUE_APP_IS_ADMIN === "1") return true; // optionnel via .env
  } catch {}
  return false;
}

// Base d’API (Vue CLI)
const BASE = String(process.env.VUE_APP_API_BASE || window.location.origin).replace(/\/+$/, "");

// Socket “no-op” par défaut (site public)
type NoopSocket = { on: (..._a: any[]) => void; off: (..._a: any[]) => void; emit: (..._a: any[]) => void; connected?: boolean };
let socket: NoopSocket = { on() {}, off() {}, emit() {}, connected: false };

// En contexte admin uniquement, on ouvre la vraie connexion
if (isAdminContext()) {
  try {
    socket = io(`${BASE}/admin`, {
      withCredentials: true,
      transports: ["websocket"], // évite le long-polling
    });

    // Logs utiles
    socket.on("connect", () => {
      // @ts-ignore
      console.info("[realtime] connected to", `${BASE}/admin`, "id=", (socket as any).id || "?");
    });
    socket.on("connect_error", (e: any) => {
      console.warn("[realtime] connect_error:", e?.message || e);
    });
    socket.on("disconnect", (reason: string) => {
      console.info("[realtime] disconnected:", reason);
    });

    // Si le serveur émet sur cet event
    socket.on("message.ingested", (payload: any) => {
      // L’app (main.ts) rebranchera l’handler central
      // Ici on ne fait rien, on expose juste l’event.
    });
  } catch (e) {
    console.warn("[realtime] init error:", (e as any)?.message || e);
  }
}

export { socket };
